import PropTypes from 'prop-types';
import { useMemo, useRef, useState } from 'react'

// Components.
import ProfilePicture from './ProfilePicture';

import { SPEAKER_ROW_PIC_SIZE } from '../constants/sizes';
import { useLongPress } from 'use-long-press';
import { Drawer } from '@mui/material';


import NoteMessage from './NoteMessage';
import useNoteDrawerPlayback from './useNoteDrawerPlayback';
import {
    displaySpeakerDescription,
    displaySpeakerName,
    canOpenSpeakerProfile,
} from './speakerHelper';


const Message = ({
    authenticated,
    curTime,
    message,
    isCurrent,
    openSpeakerInfo,
    playing,
    scrollToCurrentMessage,
    seekFn,
    speaker,
    showSpeakerDetails,
    hideNoteButton,
    onSignupRequired,
}) => {

    const messageButtonRef = useRef();
    const messageText = useMemo(() => message.message.map(word => word.text).join(''), [message.message]);
    const [showNoteDrawer, setShowNoteDrawer] = useState(false);
    useNoteDrawerPlayback(showNoteDrawer);

    const onMessageClick = () => {
        seekFn(message.timeSeconds + 0.01)()
    }

    const canOpenSpeaker = canOpenSpeakerProfile(speaker);
    const SpeakerHeaderContainer = canOpenSpeaker ? 'button' : 'div';

    const onProfileClick = () => {
        if (canOpenSpeaker) {
            openSpeakerInfo(speaker.id)();
        }
    }

    const onNoteClick = () => {
        setShowNoteDrawer(true);
    }

    const onMessageLongPress = () => {

    }

    const bindMessageLongPress = useLongPress(onMessageLongPress, {
        onCancel: event => {
            if (event.type === 'pointerup') {
                onMessageClick();
            }
        },
        filterEvents: event => true, // All events can potentially trigger long press (same as 'undefined')
        threshold: 300, // In milliseconds
        captureEvent: true, // Event won't get cleared after React finish processing it
        cancelOnMovement: 25, // Square side size (in pixels) inside which movement won't cancel long press
        cancelOutsideElement: true, // Cancel long press when moved mouse / pointer outside element while pressing
        detect: 'pointer', // Default option
    });

    const messageClassName = 'message';

    return (
        <div className='messageContainer'>
            <Drawer
                open={showNoteDrawer}
                onClose={() => setShowNoteDrawer(false)}
                // PaperProps={{
                //     sx: {
                //         borderRadius: '20px 20px 0px 0px'
                //     }
                // }}
                anchor='bottom'>
                <NoteMessage
                    open={showNoteDrawer}
                    message={message}
                    speaker={speaker}
                    trackId={message.trackId}
                    exit={() => { setShowNoteDrawer(false) }} />
            </Drawer>

            <div>
                <div style={{
                    opacity: isCurrent || !playing || !scrollToCurrentMessage ? 1.0 : 0.3,
                    // filter: isCurrent || !playing ? '' : 'blur(0.2px)',
                }}>
                    {showSpeakerDetails && speaker ?
                        <SpeakerHeaderContainer onClick={canOpenSpeaker ? onProfileClick : undefined} className='clampSafeButton' style={{ width: '100%' }}>
                            <div style={{ padding: '16px 16px 8px' }}>
                                <table style={{
                                    width: '100%',
                                    borderSpacing: 0,
                                }}>
                                    <tbody>
                                        <tr style={{ verticalAlign: 'middle' }}>
                                            <td style={{ width: '58px' }}>
                                                <ProfilePicture
                                                    speakerId={speaker.id}
                                                    borderSize={1}
                                                    imageSrc={speaker.imageURL}
                                                    anonymousDisplay={speaker.anonymousDisplay}
                                                    size={SPEAKER_ROW_PIC_SIZE}
                                                    margin='0px 12px 0px 0px' />
                                            </td>
                                            <td>
                                                <div className='speakerName' style={{ color: isCurrent || !playing ? 'var(--app-text)' : 'var(--app-text-secondary)' }}>
                                                    {displaySpeakerName(speaker)}
                                                </div>
                                                {displaySpeakerDescription(speaker) &&
                                                    <div className='speakerDescription'>
                                                        {displaySpeakerDescription(speaker)}
                                                    </div>
                                                }
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </SpeakerHeaderContainer>
                        :
                        <></>
                    }
                    <div style={{ padding: '0px 16px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <button {...bindMessageLongPress()} ref={messageButtonRef} data-transcript-message style={{ width: '100%' }}>
                            <div style={{
                                textAlign: 'left',
                                flexGrow: 1,
                            }}>
                                <div>
                                    {isCurrent ?
                                        message.message.map((word, wordIndex) => (
                                            <span key={wordIndex} className={messageClassName}
                                                style={{
                                                    opacity: !!curTime && curTime + 0.4 < word.start ? 0.5 : 1.0
                                                }}
                                            >
                                                {word.text}
                                            </span>

                                        ))
                                        :
                                        <span className={messageClassName}>
                                            {messageText}
                                        </span>
                                    }
                                </div>
                            </div>
                        </button>

                        {!hideNoteButton && !onSignupRequired &&
                            <button onClick={onNoteClick} style={{ opacity: isCurrent || !playing ? 1 : 0.7, padding: '4px', marginLeft: '12px' }}>
                                <img src='/icons/note.png' alt='Note' style={{ width: '16px', height: '16px' }} />
                            </button>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

Message.propTypes = {
    openSpeakerInfo: PropTypes.func.isRequired,
}

export default Message;
